import { observable, action } from "mobx";
import http from "@app/lib/http";
import notify from "@app/components/notify";
import { UploadService } from "@app/components/form/upload/service";

class ReportDocumentDocxImportStore {
    @observable loading = false;
    @observable previewData = null;
    @observable error = null;

    @action
    reset() {
        this.loading = false;
        this.previewData = null;
        this.error = null;
    }

    @action
    async uploadAndPreview({ projectId, file }) {
        this.loading = true;
        this.error = null;
        try {
            let fileId;
            if (file && file._id) {
                fileId = file._id;
            } else {
                const { error, data } = await UploadService.upload(file, { projectId });
                if (error || !data) {
                    throw new Error("Error uploading file");
                }
                fileId = data._id;
            }
            const { data: preview } = await http.post(
                `/project/${projectId}/report-documents/import/preview`,
                {
                    fileId,
                },
            );
            this.previewData = preview;
            return preview;
        } catch (ex) {
            this.error = ex.response?.data?.message || ex.message;
            notify.error(this.error);
            throw ex;
        } finally {
            this.loading = false;
        }
    }

    @action
    async saveImport({ projectId, docName, sections, comments }) {
        this.loading = true;
        this.error = null;
        try {
            const { data } = await http.post(`/project/${projectId}/report-documents/import/save`, {
                docName,
                sections,
                comments,
            });
            notify.success("Document imported successfully!");
            return data;
        } catch (ex) {
            this.error = ex.response?.data?.message || ex.message;
            notify.error(this.error);
            throw ex;
        } finally {
            this.loading = false;
        }
    }

    @action
    async previewImportToExisting({ projectId, reportDocumentId, file }) {
        this.loading = true;
        this.error = null;
        try {
            let fileId;
            if (file && file._id) {
                fileId = file._id;
            } else {
                const { error, data } = await UploadService.upload(file, { projectId });
                if (error || !data) {
                    throw new Error("Error uploading file");
                }
                fileId = data._id;
            }
            const {
                data: preview,
            } = await http.post(
                `/project/${projectId}/report-documents/${reportDocumentId}/import/preview`,
                { fileId },
            );
            this.previewData = preview;
            return preview;
        } catch (ex) {
            this.error = ex.response?.data?.message || ex.message;
            notify.error(this.error);
            throw ex;
        } finally {
            this.loading = false;
        }
    }

    @action
    async saveImportToExisting({ projectId, reportDocumentId, docName, sections, comments }) {
        this.loading = true;
        this.error = null;
        try {
            const {
                data,
            } = await http.post(
                `/project/${projectId}/report-documents/${reportDocumentId}/import/save`,
                { docName, sections, comments },
            );
            notify.success("Document updated successfully!");
            return data;
        } catch (ex) {
            this.error = ex.response?.data?.message || ex.message;
            notify.error(this.error);
            throw ex;
        } finally {
            this.loading = false;
        }
    }
}

export default new ReportDocumentDocxImportStore();
